export const LOGO_URL = `${process.env.PUBLIC_URL || ""}/vajron-logo.png`;

export const COMPANY = {
  name: "VAJRON Global Tech Pvt. Ltd.",
  short: "VAJRON",
  tagline: "Engineering the Future",
  phone: "+91 9818805137",
  founder: "Aryan Sharma",
  hq: "India",
};

export const DOMAIN = "vajronglobaltech.com";

export const EMAILS = {
  general: "info@vajronglobaltech.com",
  careers: "careers@vajronglobaltech.com",
  support: "support@vajronglobaltech.com",
};

export const NAV_ITEMS = [
  { to: "/", label: "Home", testid: "nav-home" },
  { to: "/solutions", label: "Solutions & Technologies", testid: "nav-solutions" },
  { to: "/about", label: "About Us", testid: "nav-about" },
  { to: "/careers", label: "Careers", testid: "nav-careers" },
  { to: "/contact", label: "Contact Us", testid: "nav-contact" },
];

export const SOLUTION_CATEGORIES = [
  {
    id: "defence",
    title: "Defence & Security Solutions",
    overline: "01 / DEFENCE",
    icon: "Shield",
    description:
      "Mission-critical aerial, autonomous, and intelligent platforms developed for strategic operations, surveillance, and force protection.",
    items: [
      { title: "Autonomous Surveillance Drones", desc: "Aerial platforms designed for persistent surveillance, reconnaissance, perimeter monitoring, and situational awareness." },
      { title: "Tethered Surveillance Drones", desc: "Long-endurance tethered systems for continuous monitoring, communication relay, and security operations." },
      { title: "Intelligent Monitoring Systems", desc: "AI-powered surveillance combining sensors, cameras, and autonomous analytics for real-time threat detection." },
      { title: "Counter-UAS & Interceptor Systems", desc: "Specialized platforms to detect, track, and intercept unauthorized aerial threats within protected zones." },
      { title: "Defensive Drone Systems", desc: "Mission-oriented platforms supporting defensive operations, reconnaissance, and force multiplication." },
      { title: "Dynamic Target Tracking Systems", desc: "AI-powered tracking and monitoring of moving objects in complex environments." },
      { title: "Customizable Manual Drone Platforms", desc: "Flexible drone architectures configurable to customer-specific payloads, sensors, and missions." },
      { title: "Customizable Autonomous Drone Platforms", desc: "Intelligent UAS capable of autonomous navigation, mission execution, and adaptive decision-making." },
      { title: "Tactical Reconnaissance Platforms", desc: "Compact aerial systems for rapid deployment, field intelligence, and operational reconnaissance." },
      { title: "Border & Perimeter Security Solutions", desc: "Integrated aerial and ground systems for continuous monitoring of critical infrastructure." },
    ],
  },
  {
    id: "government",
    title: "Government & Public Sector Solutions",
    overline: "02 / GOVERNMENT",
    icon: "Building2",
    description: "Intelligent monitoring and response platforms supporting urban management, infrastructure, and public safety operations.",
    items: [
      { title: "Smart City Monitoring Systems", desc: "AI-enabled platforms for urban management, traffic monitoring, public safety, and infrastructure oversight." },
      { title: "Disaster Response Drones", desc: "Rapid deployment aerial systems for emergency assessment and humanitarian support missions." },
      { title: "Traffic Monitoring Solutions", desc: "Autonomous systems delivering real-time traffic analysis and intelligent transportation insights." },
      { title: "Infrastructure Inspection Drones", desc: "Specialized drones for inspection of roads, bridges, power infrastructure, railways, and pipelines." },
      { title: "Environmental Monitoring Systems", desc: "Advanced sensing for environmental conditions, pollution levels, water resources, and ecology." },
      { title: "Public Safety Surveillance Systems", desc: "Integrated technologies supporting situational awareness and operational intelligence." },
    ],
  },
  {
    id: "industrial",
    title: "Industrial & Enterprise Solutions",
    overline: "03 / INDUSTRIAL",
    icon: "Factory",
    description: "Robotics, automation, and analytics platforms engineered for manufacturing, logistics, and large-scale industrial operations.",
    items: [
      { title: "Industrial Inspection Drones", desc: "High-performance inspection for manufacturing facilities, industrial plants, and warehouses." },
      { title: "Asset Monitoring Platforms", desc: "Intelligent systems for monitoring infrastructure, equipment health, and operational performance." },
      { title: "Warehouse Automation Solutions", desc: "Robotics and automation improving inventory management, logistics, and operational efficiency." },
      { title: "Industrial Robotics Systems", desc: "Custom robotic platforms for manufacturing, assembly, inspection, and repetitive processes." },
      { title: "AI-Powered Operational Analytics", desc: "Predictive insights, process optimization, and intelligent decision support." },
      { title: "Digital Twin & Monitoring Systems", desc: "Software and sensing platforms for real-time visualization of operational assets." },
    ],
  },
  {
    id: "agriculture",
    title: "Agriculture & Rural Technology Solutions",
    overline: "04 / AGRICULTURE",
    icon: "Wheat",
    description: "Precision aerial systems and intelligent platforms enabling next-generation farming and rural infrastructure.",
    items: [
      { title: "Agricultural Spraying Drones", desc: "Precision aerial spraying with improved efficiency and resource utilization." },
      { title: "Crop Monitoring Drones", desc: "Aerial imaging for crop health, field mapping, and agricultural intelligence." },
      { title: "Precision Agriculture Platforms", desc: "Integrated drone, AI, and sensor solutions for data-driven agricultural decisions." },
      { title: "Farm Survey & Mapping Systems", desc: "Autonomous mapping for terrain, crop, and land-use analysis." },
      { title: "Livestock Monitoring Solutions", desc: "Intelligent platforms for livestock management and operational oversight." },
    ],
  },
  {
    id: "robotics",
    title: "Robotics & Autonomous Systems",
    overline: "05 / ROBOTICS",
    icon: "Bot",
    description: "Custom robotic platforms and autonomous ground systems for inspection, logistics, research, and specialized missions.",
    items: [
      { title: "Unmanned Ground Vehicles (UGVs)", desc: "Autonomous and remotely operated ground platforms for inspection, surveillance, and logistics." },
      { title: "Autonomous Mobile Robots", desc: "Intelligent robots for autonomous navigation in structured and dynamic environments." },
      { title: "Inspection Robots", desc: "Robotic platforms developed for hazardous, confined, or hard-to-access environments." },
      { title: "Collaborative Robotics Solutions", desc: "Robotics designed to operate alongside humans while improving safety and productivity." },
      { title: "Custom Robotics Platforms", desc: "Tailored robotic solutions developed to meet specific operational requirements." },
    ],
  },
  {
    id: "ai-software",
    title: "Artificial Intelligence & Software Solutions",
    overline: "06 / AI · SOFTWARE",
    icon: "BrainCircuit",
    description: "AI engines, intelligent dashboards, and mission-management software powering autonomous operations and analytics.",
    items: [
      { title: "Computer Vision Systems", desc: "AI-powered image processing for detection, tracking, classification, and analytics." },
      { title: "Intelligent Decision Support Platforms", desc: "Advanced software for data-driven operational planning and strategy." },
      { title: "Autonomous Navigation Software", desc: "AI software supporting autonomous mobility, mission planning, and adaptive control." },
      { title: "AI-Based Analytics Platforms", desc: "ML and predictive analytics transforming operational data into actionable intelligence." },
      { title: "Digital Monitoring Dashboards", desc: "Centralized platforms for real-time monitoring and control of distributed assets." },
      { title: "Intelligent Mission Management Systems", desc: "Software environments for planning, coordination, and management of autonomous operations." },
    ],
  },
  {
    id: "research",
    title: "Research, Engineering & Custom Development",
    overline: "07 / R&D",
    icon: "Cpu",
    description: "Bespoke engineering, hardware, and proprietary technology development aligned to customer and future-industry needs.",
    items: [
      { title: "Custom Drone Development", desc: "Specialized drone systems tailored to unique mission requirements and environments." },
      { title: "Custom Automation Solutions", desc: "Intelligent automation for industrial, commercial, and government applications." },
      { title: "Sensor Integration Services", desc: "Integration of advanced sensors, payloads, communication systems, and intelligent tech." },
      { title: "Embedded Systems Development", desc: "Custom electronics, controllers, mission computers, and embedded platforms." },
      { title: "Mechanical & Mechatronic Engineering", desc: "Engineering services across product development, prototyping, and integration." },
      { title: "Proprietary Technology Development", desc: "Development of patented technologies and next-generation innovation platforms." },
    ],
  },
];

export const INDUSTRIES = [
  "Defence Organizations",
  "Government Agencies",
  "Public Sector Units",
  "Research Institutions",
  "Industrial Enterprises",
  "Critical Infrastructure",
  "Agriculture & Rural Tech",
  "Smart Cities",
];

export const OPENINGS = [
  { role: "Drone Systems Engineer", type: "Full-time", mode: "On-site", location: "Delhi NCR" },
  { role: "Computer Vision Engineer", type: "Full-time", mode: "Hybrid", location: "India" },
  { role: "Embedded Systems Engineer", type: "Full-time", mode: "On-site", location: "Delhi NCR" },
  { role: "Robotics & Mechatronics Engineer", type: "Full-time", mode: "On-site", location: "Bengaluru" },
  { role: "AI / ML Research Intern", type: "Internship", mode: "Remote / On-site", location: "Remote · India" },
  { role: "Autonomous Systems Intern", type: "Internship", mode: "On-site", location: "Delhi NCR" },
];
